export function convertDataBToDataA(dataB) {
  if (!dataB) {
    return { totalCount: 0, ashaList: [] };
  }
  return {
    ashaList: dataB.map((ashaANM, index) => ({
      id: index + 1,
      ashaName: ashaANM.name,
      ashaId: ashaANM.id,
      role: ashaANM.role,
      isActive: ashaANM.isActive.toLowerCase() === "active",
      contactNo: ashaANM.mobileNo,
      districtName: ashaANM.districtName,
      phcName: ashaANM.phcName,
      activeCases: ashaANM.totalActiveCases,
      totalActivityCount: ashaANM.totalActivityCount,
      joiningDate: ashaANM.joiningDate,
      paidIncentive: 0,
      reminderCount: ashaANM.remindersCount,
      talukaName: ashaANM.talukaName,
      stateName: ashaANM.stateName,
      subcenterName: ashaANM.subcenterName,
      villageName: ashaANM.villageName,
      inactiveSince: ashaANM.inactiveSince,
    })),
  };
}

export function parseIECdata(backendData) {
  return backendData.map((item) => ({
    id: item.videoid,
    videoTitle: item.videoTitle,
    validStatus: item.valid_invalid,
    categoryType: item.category || "",
    audience: item.audience || "",
    videoDescription: item.videoDescription || "",
    uploadedBy: item.uploadedBy,
    uploadedDateTime: item.uploadedDate,
    thumbnail: "",
    videoUrl: item.videoLink || "",
    remarks: item.remarks || null,
    tranId: item.videotranslationid,
  }));
}
